import {Component, computed, input} from '@angular/core';
import {IackathonSave} from '../../../../services/iackathon-saves.service';
import {IdeaCategory} from '../../../../models/iackathon-save.state';
import {MatIconModule} from '@angular/material/icon';
import {MatExpansionModule} from '@angular/material/expansion';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-iackathon-step-how-now-wow',
    imports: [
        MatIconModule,
        MatExpansionModule,
        TranslateModule
    ],
  templateUrl: './iackathon-step-how-now-wow.component.html',
})
export class IackathonStepHowNowWowComponent {
    save = input.required<IackathonSave>();
    private state = computed(() => this.save()?.attributes.content.state);
    protected readonly sortedIdeas = computed(() => this.state().solution_step.sorted_ideas);
    protected readonly conventionalImpossible = computed(() => this.sortedIdeas().filter(i => i.category === IdeaCategory.ConventionalImpossible));
    protected readonly originalImpossible = computed(() => this.sortedIdeas().filter(i => i.category === IdeaCategory.OriginalImpossible));
    protected readonly conventionalPossible = computed(() => this.sortedIdeas().filter(i => i.category === IdeaCategory.ConventionalPossible));
    protected readonly originalPossible = computed(() => this.sortedIdeas().filter(i => i.category === IdeaCategory.OriginalPossible));
}
